export const HighlightTypeValues = [
    'LAUNCH',
    'MILESTONE',
    'POST',
    'TALK',
    'VIDEO',
    'AWARD'
];
//# sourceMappingURL=highlight-type.js.map